"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _Headline = _interopRequireDefault(require("./Headline"));

var _Label = _interopRequireDefault(require("./Label"));

var _Link = _interopRequireDefault(require("./Link"));

var _Message = _interopRequireDefault(require("./Message"));

var _Paragraph = _interopRequireDefault(require("./Paragraph"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var gutter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing;

  return {
    root: {
      margin: 0,
      marginBottom: spacing(gutter)
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2.default];
});

var Text = function Text(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'paragraph' : _props$variant,
      gutter = props.gutter,
      other = (0, _objectWithoutProperties2.default)(props, ["variant", "gutter"]);
  var classes = useStyles(gutter);
  var Element = (0, _react.useMemo)(function () {
    switch (variant) {
      case 'headline1':
      case 'headline2':
      case 'headline3':
      case 'headline4':
        return _Headline.default;

      case 'message1':
      case 'message2':
      case 'message3':
      case 'message4':
        return _Message.default;

      case 'label':
        return _Label.default;

      case 'link':
        return _Link.default;

      default:
        return _Paragraph.default;
    }
  }, [variant]);
  return (0, _core.jsx)(Element, (0, _extends2.default)({
    css: classes.root,
    variant: variant
  }, other));
};

__signature__(Text, "useStyles{classes}\nuseMemo{Element}", function () {
  return [useStyles];
});

var _default = Text;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/index.tsx");
  reactHotLoader.register(Text, "Text", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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